import React, { Fragment, useCallback } from 'react';
import { PayViaEnum, TypeInvoiceEnum } from 'consts/data';
import checkBalanceModel from 'models/check-balance.model';
import NewDesign from 'components/NewDesign';
import { NavLink } from 'react-router-dom';
import { AppRoutes } from 'consts/routesPath';
import { DOWNLOAD_INVOICE_URL } from 'consts/api';
import services from 'services';
import { isLocalhost } from 'consts/data';
import { usePaymentHandler } from 'providers/PaymentProvider';
import DialogDetailInvoice from 'components/Dialogs/DialogDetailInvoice';
import useToggleDialog from 'hooks/useToggleDialog';

const propTypes = {};

const CellActionTransaction = ({ typeInvoices, transaction }) => {
  //! State
  const { id, status } = transaction || {};
  const auth = services.getLocalStorage();
  const { jwt } = auth || {};
  const { shouldOpenByPopup } = usePaymentHandler();
  const isNotEnoughBalance = checkBalanceModel.checkIsNotEnoughCredits();
  const [openDetailInvoice, toggleDetailInvoice, shouldRenderDetailInvoice] = useToggleDialog();

  //! Function
  const downloadInvoice = useCallback(
    (typeInvoice, { id, type }) =>
      () => {
        const hostname = isLocalhost ? 'http://34.102.207.102' : '';
        const link = isLocalhost
          ? '/tb/api/v2/authenticated/user/invoice/download'
          : DOWNLOAD_INVOICE_URL;

        const url = `${hostname}${link}?id=${id}&type=${type}&invoiceType=${typeInvoice}&sessionId=${jwt}`;

        window.open(
          url,
          '_blank',
          `titlebar=no,location=no,height=1000,width=1366,scrollbars=yes,status=yes`
        );
      },
    [jwt]
  );

  //! Render
  if (typeInvoices === PayViaEnum.BankTransfer || typeInvoices === PayViaEnum.Referral) {
    if (shouldOpenByPopup) {
      return (
        <Fragment>
          {shouldRenderDetailInvoice && (
            <DialogDetailInvoice isOpen={openDetailInvoice} toggle={toggleDetailInvoice} id={id} />
          )}

          <NewDesign.Typography variant='link' onClick={toggleDetailInvoice}>
            Detail
          </NewDesign.Typography>
        </Fragment>
      );
    }

    return (
      <NavLink
        to={`${AppRoutes.InvoiceDetailWithId(id)}?type=${typeInvoices}&popup=${
          isNotEnoughBalance ? true : false
        }`}
      >
        <NewDesign.Typography variant='link'>Detail</NewDesign.Typography>
      </NavLink>
    );
  }

  if (status === 'failed') {
    return '-';
  }

  return (
    <div className='component:CellActionTransaction'>
      <p>invoice</p>
      <p>
        <NewDesign.Typography
          variant='link'
          onClick={downloadInvoice(TypeInvoiceEnum.Invoice, {
            id,
            type: PayViaEnum.CreditCard,
          })}
        >
          pdf
        </NewDesign.Typography>
      </p>
      <p>
        <NewDesign.Typography
          variant='link'
          onClick={downloadInvoice(TypeInvoiceEnum.eInvoice, {
            id,
            type: PayViaEnum.CreditCard,
          })}
        >
          xml
        </NewDesign.Typography>
      </p>
    </div>
  );
};

CellActionTransaction.propTypes = propTypes;
export default CellActionTransaction;
